export default "__VITE_ASSET__YSJDV2aK__"